import angular, { IScope } from 'angular';
import { SharedAngular } from '../../../../@types/sharedAngular';
import IProcedureOverview from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureOverview';

declare interface IPropertiesScope extends IScope {
  field: any;
  procedures?: IProcedureOverview[];
}

angular.module('fg').directive('fgEditCanvasFieldProperties', [
  'fgUtils',
  'flowinglyKBService',
  'fileService',
  'workflowStore',
  'flowinglyModelUtilityService',
  'workflowFieldVariableService',
  'flowinglyConstants',
  'procedureApiService',
  function (
    fgUtils,
    flowinglyKBService,
    fileService: SharedAngular.FileService,
    workflowStore,
    flowinglyModelUtilityService: SharedAngular.FlowinglyModelUtilityService,
    workflowFieldVariableService,
    flowinglyConstants: SharedAngular.FlowinglyConstants,
    procedureApiService: SharedAngular.ProcedureApiService
  ) {
    return {
      templateUrl:
        'angular-form-gen/edit/canvas/field/properties/properties.ng.html',
      scope: {
        field: '=fgEditCanvasFieldProperties',
        allFields: '=allFields',
        nodeKey: '=?',
        nodeId: '=?'
      },
      link: {
        post: function ($scope: IPropertiesScope) {
          $scope.$watch('fieldPropertiesForm.$invalid', function (newValue) {
            $scope.field.$$_invalid = newValue;
          });

          $scope.field.nodeId = $scope.nodeId;

          if (
            $scope.field.type === flowinglyConstants.formFieldType.INSTRUCTION
          ) {
            fileService
              .replaceFileIdsWithImages($scope.field.value)
              .then((result) => {
                $scope.field.value = result;
              });

            $scope.$on('kendoWidgetCreated', function (event, widget) {
              widget.bind('paste', function (e) {
                if (e.sender && e.html) {
                  // Remove the data-file-id attribute generated for the image source from the newly inserted image through pasting.
                  e.html = e.html.replace(/data-file-id="[^"]*"/g, '');
                  const newHtml = processPastedContent(e.html);
                  if (newHtml !== null) {
                    e.html = newHtml;
                  }
                }
              });
              //to append third party fonts we need to access iframe->head object inside kendo editor and link font.
              angular
                .element(
                  angular
                    .element('.k-editable-area .k-content')[0]
                    .contentDocument.getElementsByTagName('head')
                )
                .append(
                  "<link href='https://fonts.googleapis.com/css?family=Open+Sans:400,600,700' rel='stylesheet' type='text/css'>"
                );

              const styleTag =
                widget.body.parentNode.getElementsByTagName('style')[0];
              styleTag.parentNode.removeChild(styleTag);
              widget.body.style.fontFamily = '"Open Sans", sans-serif';
              widget.body.style.fontSize = '13px';
              widget.body.style.color = '#35384D';

              // Find all the text editor and bind the execute function.
              const editorElements = $('[data-text-editor="instruction"]');

              try {
                editorElements.toArray().forEach((element) => {
                  const editor = $(element).data('kendoEditor');
                  if (editor) {
                    editor.bind('execute', editorExecute);
                  }
                });
              } catch (e) {
                // Swallow error and prevent code termination.
              }
            });

            $scope.allStepVariables = [];
            $scope.showAddVariableButton = true;
            setupVariables();

            $scope.addVariable = function (variable: string, inputId: string) {
              const editor = $(
                '.field-settings.visible .custom-email-editor textarea.k-content'
              ).data('kendoEditor');
              editor.exec('inserthtml', { value: `${variable}` });
            };

            function setupVariables() {
              const nodeDataArray = workflowStore.getNodeDataArray();
              const currentNode = flowinglyModelUtilityService.getNodeById(
                nodeDataArray,
                $scope.nodeId
              );
              $scope.showAddVariableButton = !(
                currentNode.taskType === flowinglyConstants.taskType.PUBLIC_FORM
              );
              $scope.allStepVariables =
                workflowFieldVariableService.getPriorNodesVariables(
                  $scope.nodeId,
                  null
                );
            }

            $scope.options = [
              'formatting',
              'bold',
              'italic',
              'underline',
              'fontSize',
              'strikethrough',
              'justifyLeft',
              'justifyCenter',
              'justifyRight',
              'justifyFull',
              'insertUnorderedList',
              'insertOrderedList',
              'indent',
              'outdent',
              'createLink',
              'unlink',
              'foreColor',
              'backColor',
              'insertImage',
              'insertFile',
              {
                name: 'insertVideo',
                tooltip: 'Embed Youtube Video',
                exec: (e) =>
                  $scope.$broadcast('EditorYoutubeClicked', {
                    event: e,
                    selector: `#${$scope.field.name}-textarea`
                  })
              },
              'viewHtml',
              'separator',
              {
                name: 'customTemplate',
                template: `<variable-select
                    ng-show="showAddVariableButton"
                    enabled="true"
                    target-id="field.name"
                    steps="allStepVariables"
                    on-value-selected="addVariable(variable, inputId)"
                  />`
              }
            ];

            function editorExecute(e) {
              setTimeout(function () {
                if (e.name === 'createlink') {
                  const form = e.command._dialog.element;
                  const selectors = ['#k-editor-link-target'];
                  restyleCheckBoxes(form, selectors);
                }
              }, 0);
            }

            function restyleCheckBoxes(form, targetClasses) {
              // FLOW-6400 -To get checkbox in Insert Hyperlink kendo pop-up to style similar to others in Flowingly,
              // removing the kendo checkbox default class so that global Flowingly css checkbox style will take effect.
              targetClasses.forEach((selector) => {
                const linkTarget = form.find(selector);
                if (linkTarget) {
                  linkTarget.removeClass('k-checkbox');
                }
              });
            }
          } else if ($scope.field.type === 'selectlist') {
            $scope.onChangeCallback = function () {
              initializeFieldDataSource();
            };
            initializeFieldDataSource();
          } else if ($scope.field.type === 'lookup') {
            if (!$scope.field.lookupConfig) {
              $scope.field.lookupConfig = {
                dbName: '',
                displayValue: '',
                queryValue: '',
                value: undefined
              };
            }
          } else if ($scope.field.type === 'formula') {
            flowinglyKBService
              .getKbLink('properties.' + $scope.field.type)
              .then(function (data) {
                $scope.kbLink = data;
              });
          } else if ($scope.field.type === 'attachdocument') {
            //place all attach document properties here
          } else if (
            $scope.field.type === flowinglyConstants.formFieldType.PROCEDURE
          ) {
            setProcedures();
          }

          $scope.renderInfo = fgUtils.getRenderInfo($scope.field);

          $scope.initializeFieldDataSource = initializeFieldDataSource;
          function initializeFieldDataSource() {
            const dsType = $scope.field.dataSource;
            const isManualType = !dsType || dsType == 'manually';

            $scope.dataSourceOptions = [
              {
                value: 'manually',
                text: 'Populate manually'
              },
              {
                value: 'database',
                text: 'Database'
              }
            ];

            if (isManualType) {
              $scope.field.dataSource = 'manually';
              $scope.field.dbDataSource = undefined;
              $scope.field.hideSearchableToggle = false;
            } else {
              $scope.field.searchable = true;
              $scope.field.hideSearchableToggle = true;
              if (!$scope.field.dbDataSource) {
                $scope.field.dbDataSource = {
                  dbName: '',
                  displayValue: '',
                  filters: [{}]
                };
              }
            }
          }

          function processPastedContent(html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const links = doc.querySelectorAll('a');

            links.forEach((link) => {
              const url = new URL(link.href, window.location.origin);
              // Remove the prefix if it matches the current origin and pathname
              if (
                url.origin === window.location.origin &&
                url.pathname.startsWith(window.location.pathname)
              ) {
                let newHref = url.href.replace(
                  window.location.origin + window.location.pathname,
                  ''
                );

                newHref = decodeURIComponent(newHref);
                link.href = newHref;
              } else {
                link.href = decodeURIComponent(link.href);
              }
            });

            return doc.body.innerHTML;
          }

          function setProcedures() {
            procedureApiService.getProcedures().then((procedures) => {
              procedures.sort((a, b) => a.name.localeCompare(b.name));
              $scope.procedures = procedures;
            });
          }
        }
      }
    };
  }
]);
